module.exports = function getResource(label, vars = []) {
    let resources = {
        departments: 'Departments'
    };
    return resources[label];
};
